import React, { useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledTab = styled.div`
  display: flex;
  justify-content: center;
  width: ${({ width }) => (width ? `${width}%` : 'auto')};
  cursor: pointer;
  ${({ theme }) => theme.fontFamily.mainFont.mediumExtraBold}

  ${({ selected, theme }) =>
    selected &&
    css`
      border-bottom: 2px solid ${theme.commons.tabs.borderColorActive};
    `}
`;

const Text = styled.span`
  color: ${({ theme, selected }) =>
    selected
      ? theme.commons.tabs.textColorActive
      : theme.commons.tabs.textColor};
`;

function Tab({ id, onClick, selected, text, width }) {
  const tabRef = useRef(null);

  const handleClick = useCallback(() => {
    onClick(id, tabRef.current);
  }, [onClick, id]);

  useEffect(() => {
    if (selected && tabRef.current) {
      tabRef.current.scrollIntoView({ inline: 'start' });
    }
  }, [selected]);

  return (
    <StyledTab
      selected={selected}
      onClick={handleClick}
      width={width}
      ref={tabRef}
    >
      <Text selected={selected}>{text}</Text>
    </StyledTab>
  );
}

Tab.propTypes = {
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  width: PropTypes.number,
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default Tab;
